import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from 'components/Loader/index';
import GridWrapper from '../../../../custom-hooks/GridWrapper';
import { setApi } from '../../../../reducers/grid';



const init = {
    // key: 'get_order_comments_email_history',
    key: 'get_comments_email_history_new',
};
const gridKey = `${init.key}_${init.path || ''}`;

const CommentEmailHistory = props => {
    const [loadingState, setLoadingState] = useState(true);
    const { entityId, updateApiGrid } = props;

    const getParams = () => ({
        selectItem: () => {}
    });

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    useEffect(() => {
        entityId && updateApiGrid({ entityName: 'COMMENT', entityId }, gridKey);
    }, [entityId]);

    return (
        <div className='content-wrapper'>
            {loadingState && <Loader />}
            <GridWrapper
                tuner={() => (init)}
                initUpdate={false}
                gridParams={getParams()}
                onStart={onStart}
                onFinish={onFinish}
            />
        </div>
    );
};

export default connect(null, { updateApiGrid: setApi })(
    withRouter(CommentEmailHistory)
);
